import { PLACE_ICONS } from '@/utils/seatSelection';
import React, { useEffect, useState } from 'react';
import { Image } from 'react-konva';

interface PlaceIconProps {
  x: number;
  y: number;
  size: number;
  iconKey: keyof typeof PLACE_ICONS;
  color?: string;
}

const PlaceIcon: React.FC<PlaceIconProps> = ({
  x,
  y,
  size,
  iconKey,
  color,
}) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const loadSvgIcon = () => {
      const placeIcon = PLACE_ICONS[iconKey];

      if (color) {
        placeIcon.replace(/currentColor/g, color);
      }

      const encodedSvg = encodeURIComponent(placeIcon);
      const dataUrl = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;

      const img = new window.Image();
      img.onload = () => setImage(img);
      img.src = dataUrl;
    };

    loadSvgIcon();
  }, [color, iconKey]);

  if (!image) return null;

  return (
    <Image
      image={image}
      width={size}
      height={size}
      x={x - size / 2}
      y={y - size / 2}
    />
  );
};

export default PlaceIcon;
